"use strict";

exports.__esModule = true;
exports.stationName = void 0;
/**
 * Get the name of where the measurement has been done, usually the name of the
 * air quality station
 *
 * @param openaq - The OpenAQ format normalized data
 */

function stationName(data) {
  if (data.attribution && data.attribution.length) {
    return data.attribution[0].name;
  }

  return "Station " + data.location;
}

exports.stationName = stationName;